/* ЕДИНСТВЕННЫЙ источник иконок в приложении — Ionicons (https://ionic.io/ionicons).
   Правило: никаких других наборов (lucide, heroicons, эмодзи-глифы) в UI не появляется.
   Новая иконка = новая строка здесь, имя файла берём с ionic.io/ionicons как есть.

   Каждая иконка есть в двух видах:
     Ion.wallet        — outline (штриховая), основной вид;
     Ion.walletSolid   — filled, для активных состояний и для подложек (IconTile).

   Компоненты принимают `size` (число, px) и обычные svg-пропсы. Цвет — currentColor
   либо style={{ color: … }}, как во всём остальном интерфейсе. */

import React from "react";

/* ── outline ── */
import AddSvg from "ionicons-svg/add-outline.svg?react";
import AlertCircleSvg from "ionicons-svg/alert-circle-outline.svg?react";
import AttachSvg from "ionicons-svg/attach-outline.svg?react";
import BarChartSvg from "ionicons-svg/bar-chart-outline.svg?react";
import BriefcaseSvg from "ionicons-svg/briefcase-outline.svg?react";
import BulbSvg from "ionicons-svg/bulb-outline.svg?react";
import CalendarSvg from "ionicons-svg/calendar-outline.svg?react";
import CardSvg from "ionicons-svg/card-outline.svg?react";
import CallSvg from "ionicons-svg/call-outline.svg?react";
import ChatboxSvg from "ionicons-svg/chatbox-outline.svg?react";
import ChatbubblesSvg from "ionicons-svg/chatbubble-ellipses-outline.svg?react";
import CheckboxSvg from "ionicons-svg/checkbox-outline.svg?react";
import CheckmarkSvg from "ionicons-svg/checkmark-outline.svg?react";
import CheckmarkCircleSvg from "ionicons-svg/checkmark-circle-outline.svg?react";
import CheckmarkDoneSvg from "ionicons-svg/checkmark-done-outline.svg?react";
import ChevronDownSvg from "ionicons-svg/chevron-down-outline.svg?react";
import ChevronForwardSvg from "ionicons-svg/chevron-forward-outline.svg?react";
import ChevronUpSvg from "ionicons-svg/chevron-up-outline.svg?react";
import CloseSvg from "ionicons-svg/close-outline.svg?react";
import CloudUploadSvg from "ionicons-svg/cloud-upload-outline.svg?react";
import CopySvg from "ionicons-svg/copy-outline.svg?react";
import DocumentTextSvg from "ionicons-svg/document-text-outline.svg?react";
import EllipseSvg from "ionicons-svg/ellipse-outline.svg?react";
import EllipsisSvg from "ionicons-svg/ellipsis-horizontal-outline.svg?react";
import FileTraySvg from "ionicons-svg/file-tray-outline.svg?react";
import FlagSvg from "ionicons-svg/flag-outline.svg?react";
import FolderSvg from "ionicons-svg/folder-outline.svg?react";
import FlashSvg from "ionicons-svg/flash-outline.svg?react";
import FlameSvg from "ionicons-svg/flame-outline.svg?react";
import FunnelSvg from "ionicons-svg/funnel-outline.svg?react";
import GridSvg from "ionicons-svg/grid-outline.svg?react";
import HardwareChipSvg from "ionicons-svg/hardware-chip-outline.svg?react";
import HeadsetSvg from "ionicons-svg/headset-outline.svg?react";
import HourglassSvg from "ionicons-svg/hourglass-outline.svg?react";
import ImageSvg from "ionicons-svg/image-outline.svg?react";
import KeySvg from "ionicons-svg/key-outline.svg?react";
import MailSvg from "ionicons-svg/mail-outline.svg?react";
import LinkSvg from "ionicons-svg/link-outline.svg?react";
import ListSvg from "ionicons-svg/list-outline.svg?react";
import LocateSvg from "ionicons-svg/locate-outline.svg?react";
import LockClosedSvg from "ionicons-svg/lock-closed-outline.svg?react";
import LogOutSvg from "ionicons-svg/log-out-outline.svg?react";
import MicSvg from "ionicons-svg/mic-outline.svg?react";
import MoonSvg from "ionicons-svg/moon-outline.svg?react";
import NewspaperSvg from "ionicons-svg/newspaper-outline.svg?react";
import NotificationsSvg from "ionicons-svg/notifications-outline.svg?react";
import PaperPlaneSvg from "ionicons-svg/paper-plane-outline.svg?react";
import PencilSvg from "ionicons-svg/pencil-outline.svg?react";
import PeopleSvg from "ionicons-svg/people-outline.svg?react";
import PersonSvg from "ionicons-svg/person-outline.svg?react";
import PersonAddSvg from "ionicons-svg/person-add-outline.svg?react";
import PhonePortraitSvg from "ionicons-svg/phone-portrait-outline.svg?react";
import PinSvg from "ionicons-svg/pin-outline.svg?react";
import RefreshSvg from "ionicons-svg/refresh-outline.svg?react";
import ReorderThreeSvg from "ionicons-svg/reorder-three-outline.svg?react";
import RepeatSvg from "ionicons-svg/repeat-outline.svg?react";
import SearchSvg from "ionicons-svg/search-outline.svg?react";
import ShieldSvg from "ionicons-svg/shield-outline.svg?react";
import ShieldCheckmarkSvg from "ionicons-svg/shield-checkmark-outline.svg?react";
import SparklesSvg from "ionicons-svg/sparkles-outline.svg?react";
import SunnySvg from "ionicons-svg/sunny-outline.svg?react";
import SwapHorizontalSvg from "ionicons-svg/swap-horizontal-outline.svg?react";
import TimeSvg from "ionicons-svg/time-outline.svg?react";
import TrashSvg from "ionicons-svg/trash-outline.svg?react";
import TrendingUpSvg from "ionicons-svg/trending-up-outline.svg?react";
import VideocamSvg from "ionicons-svg/videocam-outline.svg?react";
import WalletSvg from "ionicons-svg/wallet-outline.svg?react";
import WarningSvg from "ionicons-svg/warning-outline.svg?react";

/* ── filled ── */
import BarChartFillSvg from "ionicons-svg/bar-chart.svg?react";
import BriefcaseFillSvg from "ionicons-svg/briefcase.svg?react";
import CardFillSvg from "ionicons-svg/card.svg?react";
import CheckmarkCircleFillSvg from "ionicons-svg/checkmark-circle.svg?react";
import DocumentTextFillSvg from "ionicons-svg/document-text.svg?react";
import DownloadFillSvg from "ionicons-svg/download.svg?react";
import EllipsisFillSvg from "ionicons-svg/ellipsis-horizontal.svg?react";
import FlagFillSvg from "ionicons-svg/flag.svg?react";
import FolderFillSvg from "ionicons-svg/folder.svg?react";
import FlashFillSvg from "ionicons-svg/flash.svg?react";
import LockClosedFillSvg from "ionicons-svg/lock-closed.svg?react";
import RepeatFillSvg from "ionicons-svg/repeat.svg?react";
import GridFillSvg from "ionicons-svg/grid.svg?react";
import HardwareChipFillSvg from "ionicons-svg/hardware-chip.svg?react";
import HeadsetFillSvg from "ionicons-svg/headset.svg?react";
import KeyFillSvg from "ionicons-svg/key.svg?react";
import ListFillSvg from "ionicons-svg/list.svg?react";
import LocateFillSvg from "ionicons-svg/locate.svg?react";
/* У логотипов в Ionicons варианта outline нет — только залитый */
import LogoInstagramSvg from "ionicons-svg/logo-instagram.svg?react";
import MicFillSvg from "ionicons-svg/mic.svg?react";
import LogOutFillSvg from "ionicons-svg/log-out.svg?react";
import MoonFillSvg from "ionicons-svg/moon.svg?react";
import NotificationsFillSvg from "ionicons-svg/notifications.svg?react";
import PersonFillSvg from "ionicons-svg/person.svg?react";
import PhonePortraitFillSvg from "ionicons-svg/phone-portrait.svg?react";
import PinFillSvg from "ionicons-svg/pin.svg?react";
import PlayFillSvg from "ionicons-svg/play.svg?react";
import ShieldCheckmarkFillSvg from "ionicons-svg/shield-checkmark.svg?react";
import SparklesFillSvg from "ionicons-svg/sparkles.svg?react";
import SunnyFillSvg from "ionicons-svg/sunny.svg?react";
import VideocamFillSvg from "ionicons-svg/videocam.svg?react";
import WalletFillSvg from "ionicons-svg/wallet.svg?react";

/* Обёртка: сохраняет привычный вызов <Ion.wallet size={18} /> и не даёт иконке сжаться во флексе. */
const ion = (Svg, name) => {
  const C = ({ size = 20, className = "", style, ...rest }) => (
    <Svg
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      className={`shrink-0 ${className}`}
      style={style}
      {...rest}
    />
  );
  C.displayName = `Ion.${name}`;
  return C;
};

export const Ion = {
  add: ion(AddSvg, "add"),
  alertCircle: ion(AlertCircleSvg, "alertCircle"),
  attach: ion(AttachSvg, "attach"),
  barChart: ion(BarChartSvg, "barChart"),
  briefcase: ion(BriefcaseSvg, "briefcase"),
  bulb: ion(BulbSvg, "bulb"),
  calendar: ion(CalendarSvg, "calendar"),
  card: ion(CardSvg, "card"),
  call: ion(CallSvg, "call"),
  chatbox: ion(ChatboxSvg, "chatbox"),
  chatbubbles: ion(ChatbubblesSvg, "chatbubbles"),
  checkbox: ion(CheckboxSvg, "checkbox"),
  checkmark: ion(CheckmarkSvg, "checkmark"),
  checkmarkCircle: ion(CheckmarkCircleSvg, "checkmarkCircle"),
  checkmarkDone: ion(CheckmarkDoneSvg, "checkmarkDone"),
  chevronDown: ion(ChevronDownSvg, "chevronDown"),
  chevronForward: ion(ChevronForwardSvg, "chevronForward"),
  chevronUp: ion(ChevronUpSvg, "chevronUp"),
  close: ion(CloseSvg, "close"),
  cloudUpload: ion(CloudUploadSvg, "cloudUpload"),
  copy: ion(CopySvg, "copy"),
  documentText: ion(DocumentTextSvg, "documentText"),
  ellipse: ion(EllipseSvg, "ellipse"),
  ellipsis: ion(EllipsisSvg, "ellipsis"),
  fileTray: ion(FileTraySvg, "fileTray"),
  flag: ion(FlagSvg, "flag"),
  flame: ion(FlameSvg, "flame"),
  folder: ion(FolderSvg, "folder"),
  flash: ion(FlashSvg, "flash"),
  funnel: ion(FunnelSvg, "funnel"),
  grid: ion(GridSvg, "grid"),
  hardwareChip: ion(HardwareChipSvg, "hardwareChip"),
  headset: ion(HeadsetSvg, "headset"),
  hourglass: ion(HourglassSvg, "hourglass"),
  image: ion(ImageSvg, "image"),
  key: ion(KeySvg, "key"),
  link: ion(LinkSvg, "link"),
  list: ion(ListSvg, "list"),
  logoInstagram: ion(LogoInstagramSvg, "logoInstagram"),
  locate: ion(LocateSvg, "locate"),
  lockClosed: ion(LockClosedSvg, "lockClosed"),
  mail: ion(MailSvg, "mail"),
  logOut: ion(LogOutSvg, "logOut"),
  mic: ion(MicSvg, "mic"),
  moon: ion(MoonSvg, "moon"),
  newspaper: ion(NewspaperSvg, "newspaper"),
  notifications: ion(NotificationsSvg, "notifications"),
  paperPlane: ion(PaperPlaneSvg, "paperPlane"),
  pencil: ion(PencilSvg, "pencil"),
  people: ion(PeopleSvg, "people"),
  person: ion(PersonSvg, "person"),
  personAdd: ion(PersonAddSvg, "personAdd"),
  phonePortrait: ion(PhonePortraitSvg, "phonePortrait"),
  pin: ion(PinSvg, "pin"),
  refresh: ion(RefreshSvg, "refresh"),
  reorderThree: ion(ReorderThreeSvg, "reorderThree"),
  repeat: ion(RepeatSvg, "repeat"),
  search: ion(SearchSvg, "search"),
  shield: ion(ShieldSvg, "shield"),
  shieldCheckmark: ion(ShieldCheckmarkSvg, "shieldCheckmark"),
  sparkles: ion(SparklesSvg, "sparkles"),
  sunny: ion(SunnySvg, "sunny"),
  swapHorizontal: ion(SwapHorizontalSvg, "swapHorizontal"),
  time: ion(TimeSvg, "time"),
  trash: ion(TrashSvg, "trash"),
  trendingUp: ion(TrendingUpSvg, "trendingUp"),
  videocam: ion(VideocamSvg, "videocam"),
  wallet: ion(WalletSvg, "wallet"),
  warning: ion(WarningSvg, "warning"),

  barChartSolid: ion(BarChartFillSvg, "barChartSolid"),
  briefcaseSolid: ion(BriefcaseFillSvg, "briefcaseSolid"),
  cardSolid: ion(CardFillSvg, "cardSolid"),
  checkmarkCircleSolid: ion(CheckmarkCircleFillSvg, "checkmarkCircleSolid"),
  documentTextSolid: ion(DocumentTextFillSvg, "documentTextSolid"),
  downloadSolid: ion(DownloadFillSvg, "downloadSolid"),
  ellipsisSolid: ion(EllipsisFillSvg, "ellipsisSolid"),
  flagSolid: ion(FlagFillSvg, "flagSolid"),
  folderSolid: ion(FolderFillSvg, "folderSolid"),
  flashSolid: ion(FlashFillSvg, "flashSolid"),
  lockClosedSolid: ion(LockClosedFillSvg, "lockClosedSolid"),
  repeatSolid: ion(RepeatFillSvg, "repeatSolid"),
  gridSolid: ion(GridFillSvg, "gridSolid"),
  hardwareChipSolid: ion(HardwareChipFillSvg, "hardwareChipSolid"),
  headsetSolid: ion(HeadsetFillSvg, "headsetSolid"),
  keySolid: ion(KeyFillSvg, "keySolid"),
  listSolid: ion(ListFillSvg, "listSolid"),
  locateSolid: ion(LocateFillSvg, "locateSolid"),
  micSolid: ion(MicFillSvg, "micSolid"),
  logOutSolid: ion(LogOutFillSvg, "logOutSolid"),
  moonSolid: ion(MoonFillSvg, "moonSolid"),
  notificationsSolid: ion(NotificationsFillSvg, "notificationsSolid"),
  personSolid: ion(PersonFillSvg, "personSolid"),
  phonePortraitSolid: ion(PhonePortraitFillSvg, "phonePortraitSolid"),
  pinSolid: ion(PinFillSvg, "pinSolid"),
  playSolid: ion(PlayFillSvg, "playSolid"),
  shieldCheckmarkSolid: ion(ShieldCheckmarkFillSvg, "shieldCheckmarkSolid"),
  sparklesSolid: ion(SparklesFillSvg, "sparklesSolid"),
  sunnySolid: ion(SunnyFillSvg, "sunnySolid"),
  videocamSolid: ion(VideocamFillSvg, "videocamSolid"),
  walletSolid: ion(WalletFillSvg, "walletSolid"),
};

/* Иконка на цветной подложке — как в списках Konsta / настройках iOS.
   Ставится в `media` у ListItem: <ListItem media={<IconTile icon={Ion.walletSolid} bg="…" />} /> */
export function IconTile({ icon: Icon, bg, size = 29, iconSize = 17, className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-[7px] text-white ${className}`}
      style={{ width: size, height: size, background: bg }}
    >
      <Icon size={iconSize} />
    </span>
  );
}

export default Ion;
